import React from "react";
import { STRINGS } from "../../strings";
import CustomModal from "../../../../components/Modals/CustomModal";
import { Button } from "../../../../components/Buttons";
import classes from "./DealsComp.module.css";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import TypographyInline from "../../../../components/Typography/TypographyInline";

const WarningModalMeetingCrm = ({
  open,
  close,

  setForceCreate,
  errMessage,
}) => {
  const cancelHandle = () => {
    close(!open);
  };

  const createHandle = () => {
    close(!open);
    setForceCreate(true);
  };

  const modalHeaderData = {
    heading: {
      id: STRINGS.LOG_MEETING,
      label: STRINGS.WARNING,
    },
  };

  const modalBodyData = (
    <div>
      <TypographyInline
        size={"sm"}
        color={GREY.TERTIARY}
        fontWeight={fontWeight.REGULAR}
        label={errMessage}
      />
      <TypographyInline
        size={"sm"}
        color={GREY.TERTIARY}
        fontWeight={fontWeight.REGULAR}
        label={"Are you still want to Create this meeting?"}
      />
    </div>
  );
  const modalFooterRightData = (
    <div className={classes.modalFooterRightData}>
      <Button
        label={STRINGS.CANCEL}
        onClick={cancelHandle}
        variant={"ghost"}
        size={"sm36"}
      />
      <Button
        label={STRINGS.CREATE}
        size={"sm36"}
        variant={"primary"}
        onClick={createHandle}
        //   isLoading={loading}
      />
    </div>
  );

  const modalFooterLeftData = <div></div>;
  return (
    <CustomModal
      width={"41.667vw"}
      close={cancelHandle}
      open={open}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{
        left: modalFooterLeftData,
        right: modalFooterRightData,
      }}
      variant={"error"}
    />
  );
};

export default WarningModalMeetingCrm;
